"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vessel_rate_types_1 = require("../../model/enum/vessel-rate-types");
function getRateNameForCustomer(rateModel) {
    return getRateName(rateModel, null);
}
exports.getRateNameForCustomer = getRateNameForCustomer;
function getRateNameForPayouts(rateModel) {
    return getRateName(rateModel, 'Rate');
}
exports.getRateNameForPayouts = getRateNameForPayouts;
function getRateName(rateModel, endingText) {
    if (!rateModel)
        return;
    let rateName = rateModel.rateType;
    if (rateModel.rateType === vessel_rate_types_1.RateType.Custom ||
        rateModel.rateType === vessel_rate_types_1.RateType.CustomTimeBased) {
        rateName = rateModel.name;
    }
    else if (rateModel.rateType === vessel_rate_types_1.RateType.Owner) {
        rateName = `Boat rental`;
    }
    else if (rateModel.rateType === vessel_rate_types_1.RateType.Captain) {
        rateName = vessel_rate_types_1.RateType.Captain;
    }
    else if (rateModel.rateType === vessel_rate_types_1.RateType.Crew) {
        rateName = vessel_rate_types_1.RateType.Crew;
    }
    else if (rateModel.rateType === vessel_rate_types_1.RateType.FuelIncluded) {
        return 'Prepaid Fuel';
    }
    else if (rateModel.rateType === vessel_rate_types_1.RateType.Cleaning) {
        rateName = vessel_rate_types_1.RateType.Cleaning;
    }
    if (endingText && endingText.length) {
        rateName = `${rateName} ${endingText.toLowerCase()}`;
    }
    return rateName;
}
exports.getRateName = getRateName;
